export default __webpack_public_path__ + "static/media/touchCoin.b91f407f.svg";